import styled from 'styled-components';

export const NavBarContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const SidebarLogo = styled.div`
    display: flex;
    width: 100px;
`;

export const NavBarRow = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    width: 100%;
`;

export const LogosStack = styled.div<{ $isSidebarOpen: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
    padding-left: ${({ $isSidebarOpen }) => ($isSidebarOpen ? '270px' : '0')};
    transition: padding-left 0.3s ease;
`;

export const ActionsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 16px 36px;
`;

export const Line = styled.div`
    background-color: ${({theme}) => theme.palette.dividers.light};
    height: 1px;
    width: 100%;
`;
